<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                        :repository="repositories.paciente"
                        v-model="paciente"
                        :text-field="(item) => item.cidadao.nome"
                        label="Paciente"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        label="Data de nascimento"
                        v-model="model.dataNascimento"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave"
            :fields="fields"
            ref="Table"
            sort-by="pacienteNome"
            hide-filters
        >
            <template v-slot:cell(pacienteNome)="row">
                {{ row.item.pacienteNome }}

                <template v-if="row.item.nomeSocial">
                    <template v-if="row.item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ row.item.nomeSocial }})</strong>
                    </template>

                    <template v-else>
                        <strong>({{ row.item.nomeSocial }})</strong>
                    </template>
                </template>
            </template>

            <template v-slot:cell(pacienteTelefone)="row">
                <template v-if="row.item.pacienteTelefone == '0000000000' || !row.item.pacienteTelefone">
                    -
                </template>
                <template v-else>
                    {{ row.item.pacienteTelefone | formatPhoneOrCellPhone }}
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="imprimirHistorico(item)"
                    color="info"
                    small
                    title="Imprimir histórico"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    color="primary"
                    small
                    title="Visualizar agendamentos"
                    @click="sendAgendamento(item)"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, data, stringCase } from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'


// Moment.
import moment from 'moment'

export default {
    computed: {
         fields() {
            const fields = [
                {
                    key: "pacienteNome",
                    label: "Paciente",
                    sortable: true
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    sortable: true
                },
                {
                    key: "nomeMae",
                    label: "Nome da mãe",
                    sortable: true
                },
                {
                    key: "prontuario",
                    label: "Prontuário",
                    sortable: true
                },
                {
                    key: "pacienteTelefone",
                    label: "Telefone",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
    },
    created() {

        this.repositories = {
            exameAgendadoRealizado: this.getConectaSusRepository('exameImagem.exameAgendadoRealizado'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
        itemsNotSave: null,
        enums: { preferenciaNome },
        paciente: null,
        localPaciente: {
            autocompleteFieldsPaciente: {
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            },
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.exameAgendadoRealizado.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {

            this.setLoading()

            this.repositories.exameAgendadoRealizado.datatable(this.getSearchParams())
                .then(({ data }) =>

                    this.itemsNotSave = data
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

          const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.dataNascimento) {

                params.dataNascimento = moment(this.model.dataNascimento).format('YYYY-MM-DD')
            }

            return this.camelObjectKeysToSnakeRecursive(params)

        },
        sendAgendamento(item){

            this.$router.push({ name: 'exame-imagem-exame-agendado-realizado-create', params: { id: item.pacienteId },  })

        },
        resetForm() {

            this.model.prontuario =  null
            this.paciente = null
            this.model.dataNascimento = null

            this.$nextTick()
                .then(() => {

                    this.resetDatatable()
                })
        },
        resetDatatable(){

            this.itemsNotSave = null
        },
        imprimirHistorico(item){

            this.setLoading()

            this.repositories.impressao.historicoExame(item.pacienteId)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, object, data, stringCase],
    filters: {
        ...format,
    },
}
</script>